import { Button } from '@/plugins/ant-design-vue/tsx-support'
import { Component, Mixins } from '@/vue-property-decorator'
import {
  GlobalEventActions,
  GlobalEventActionsTypeEnum
} from '@/context/events'
import { GlobalEvents } from '@/context'
import { createSvgSprite } from '@/utils/business-utils/assets'
import { useDownloadAppStore } from '@/layouts/components/downloadApp/store'
import { useI18n } from '@/i18n'
import { useMainStore } from '@/store/index'
import BaseMixins from './mixin/index'
import BusinessUtils from '@/utils/business-utils'
import Modal from '@/controller/Modal'
import TooltipsComp from '@/components/business-components/tooltips'
import isMobile from '@/utils/isMobile'
import style from './style.module.scss'
/**通过点击游戏后触发该弹出框 */
@Component<DownlodAppByClickGame>({ name: 'DownlodAppByClickGame' })
export default class DownlodAppByClickGame extends Mixins(BaseMixins) {
  private handleDownloadApp(action: GlobalEventActions) {
    if (
      action.type ===
      GlobalEventActionsTypeEnum.DOWNLOAD_APP_BY_AFTER_CLICK_GAME
    ) {
      this.downloadAppByClickGame()
    }
  }

  created() {
    GlobalEvents.subscribe(this.handleDownloadApp)
  }

  beforeDestroy() {
    GlobalEvents.unsubscribe(this.handleDownloadApp)
  }

  private async downloadAppByClickGame() {
    const urlslist = await useDownloadAppStore().getDownloadConfig(
      this.downloadAppByClickGame
    )
    const { downloadAppReward, siteConfig } = useMainStore()
    const formatedDownloadAppReward = this.formatDownloadAppReward
    Modal.create({
      closable: true,
      hiddenBtns: true,
      class: style.downloadModal,
      width: BusinessUtils.px2rem(600),
      content: () => {
        const { t } = useI18n()
        return (
          <div class={style.downloadContent}>
            <div class={style.logo}>
              <my-img
                src={
                  siteConfig?.appIconBigPath ||
                  siteConfig?.appIconSmallPath ||
                  ''
                }
              />
              <span class={style.title}>
                {t('lobby.rightBar.downloadTitleFromClickGame')}
              </span>
            </div>
            <div
              class={style.wrapperUrlslist}
              ref={'downloadBtnRef'}
              data-clipboard-text={this.getClipBoardParams}
            >
              {urlslist?.map((item, index) => {
                let count = 0
                return (
                  <Button.Tsx
                    key={item.name}
                    type="primary"
                    ghost={!(index % 2)}
                    class={style.downloadItem}
                    onClick={() => {
                      this.handlerDownloadBtn(item, count)
                      count++
                    }}
                  >
                    {!!downloadAppReward && (
                      <TooltipsComp
                        charge={1}
                        top={BusinessUtils.px2rem(-20)}
                        text={formatedDownloadAppReward}
                      />
                    )}
                    <icon-sprite
                      class={style.appIcon}
                      sprite={
                        isMobile().apple.device
                          ? createSvgSprite('comm_icon_xz-ios')
                          : createSvgSprite('comm_icon_xz-android')
                      }
                    />

                    <span class={style.appName}>{item.name}</span>
                  </Button.Tsx>
                )
              })}
            </div>
          </div>
        )
      }
    })
    this.$nextTick(this.createClipBoard)
  }
}
